import Vue from 'vue';
import {
  Button,
  Checkbox,
  CellGroup,
  Cell,
  CountDown,
  Dialog,
  Empty,
  Form,
  Field,
  Grid,
  GridItem,
  Loading,
  PasswordInput,
  Picker,
  Popup,
  RadioGroup,
  Radio,
  Steps,
  Step,
  Tabs,
  Tab,
  Tag,
  Uploader,
  Row,
  Col,
} from 'vant';

Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(CountDown);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Form);
Vue.use(Field);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Loading);
Vue.use(PasswordInput);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Tag);
Vue.use(Uploader);
Vue.use(Row);
Vue.use(Col);
